/**
 * Convert the query object to query url
 * @param  {Object} query - The query to convert
 * @return {String} - The url
 */
export const convertQuery = (query) => {
	return Object.entries(query)
		.filter(([key, value]) => (value instanceof Array) ? value.length > 0 : (value !== '' && value !== undefined && value !== null))
		.reduce((values, [attribute, value]) => {
			if (value instanceof Array) {
				values.splice(-1, 0, ...value.map(item => [attribute, item]));
			} else {
				values.push([attribute, value]);
			}
			return values;
		}, [])
		.map(([name, value]) => `${encodeURIComponent(name)}=${encodeURIComponent(value)}`)
		.join("&");
};

/**
 * Split the query url to object for the form
 * @param  {String} query - The query to convert into object
 * @return {Object} - The query object
 */
export const splitQuery = (query) => {
	if (!query) {
		return {};
	}

	return query.split('&').reduce((accumulator, querySegment) => {
		const [ name, param ] = querySegment.split('=');
		const decodedName = decodeURIComponent(name);

		accumulator[decodedName] = accumulator[decodedName] || null;

		if (!accumulator[decodedName]) {
			accumulator[decodedName] = [decodeURIComponent(param)];
		} else {
			accumulator[decodedName] = Array.isArray(accumulator[decodedName]) ? accumulator[decodedName] : [accumulator[decodedName]];
			accumulator[decodedName].push(decodeURIComponent(param));
		}

		return accumulator;
	}, {});
};
